import { END_POINTS } from "../helpers";
import { CommonBody, Partner } from "../types/General";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

export const partnerApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllPartners: builder.query<
      CommonResponse & { data: Partner },
      { page: number; search: string; status: number }
    >({
      query: ({ page, search, status }) => ({
        url: `${END_POINTS.partner}?page=${page}&search=${search}&status=${status}`,
        method: "GET",
      }),
    }),

    partnerStatus: builder.mutation<
      CommonResponse & { data: Partner },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.partner}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    partnerDetails: builder.query<
      CommonResponse & { data: Partner },
      { id: string | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.partner}/${id}`,
        method: "GET",
      }),
    }),

    deletePartner: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.partner}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetAllPartnersQuery,
  usePartnerStatusMutation,
  useLazyPartnerDetailsQuery,
  useLazyDeletePartnerQuery,
} = partnerApi;
